import { render, staticRenderFns } from "./my-vip.vue?vue&type=template&id=3d80bdb0&scoped=true&"
import script from "./my-vip.vue?vue&type=script&lang=js&"
export * from "./my-vip.vue?vue&type=script&lang=js&"
import style0 from "./my-vip.vue?vue&type=style&index=0&id=3d80bdb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80bdb0",
  null
  
)

export default component.exports